// Update portal-frontend constants as well
export const UserStatus = {
	Inactive: 1,
	Active: 2,
	Locked: 3,
	Suspended: 4,
	Banned: 5,
	'Self Excluded': 6,
	Break: 7,
};

export const transactionType = {
	DEBIT: 1,
	CREDIT: 2,
};
